import type { Services } from "@/lib/services"
import { emptyServicesCollection } from "@/lib/services/constants"

export const isValidServiceOption = (
  service: unknown
): service is Services.Option => {
  if (typeof service !== `string`) {
    return false
  }

  return Object.hasOwn(emptyServicesCollection, service)
}
